import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { formatApiError } from "@/lib/api";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await register(name, email, password);
      toast.success("ಖಾತೆ ರಚಿಸಲಾಗಿದೆ!");
      navigate("/");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || "ನೋಂದಣಿ ವಿಫಲ");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-md mx-auto py-10">
      <div className="border border-border rounded-sm p-8 bg-card paper-noise">
        <div className="font-ui text-xs uppercase tracking-[0.3em] text-muted-foreground">Sign Up</div>
        <h1 className="font-kannada-heading text-3xl mt-1">ಹೊಸ ಖಾತೆ ರಚಿಸಿ</h1>

        <form onSubmit={submit} className="mt-6 space-y-4">
          <div>
            <Label htmlFor="name" className="text-xs uppercase tracking-widest">Name</Label>
            <Input
              id="name"
              required
              value={name}
              onChange={(e) => setName(e.target.value)}
              className="rounded-none mt-1"
              data-testid="register-name"
            />
          </div>
          <div>
            <Label htmlFor="email" className="text-xs uppercase tracking-widest">Email</Label>
            <Input
              id="email"
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="rounded-none mt-1"
              data-testid="register-email"
            />
          </div>
          <div>
            <Label htmlFor="password" className="text-xs uppercase tracking-widest">Password</Label>
            <Input
              id="password"
              type="password"
              required
              minLength={4}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="rounded-none mt-1"
              data-testid="register-password"
            />
          </div>
          <Button type="submit" disabled={loading} className="w-full rounded-none" data-testid="register-submit">
            {loading ? "ಸೃಷ್ಟಿಸುತ್ತಿದೆ..." : "ನೋಂದಣಿ ಮಾಡಿ"}
          </Button>
        </form>

        <p className="text-sm text-muted-foreground mt-6">
          ಈಗಾಗಲೇ ಖಾತೆ ಇದೆಯೇ?{" "}
          <Link to="/login" className="text-primary font-semibold underline underline-offset-4" data-testid="go-login">
            ಲಾಗಿನ್
          </Link>
        </p>
      </div>
    </div>
  );
}
